
import Loading from './loading'

export default Loading



// WEBPACK FOOTER //
// ./src/components/loading/index.js